import { Field } from "formik";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
// SubForms
import { SalutationSubForm, Schema as SalutationSchema } from '../subforms/Salutation';
import { DocumentsSubForm, Schema as DocumentsSchema } from '../subforms/Documents';
import { OtherInformationSubForm, Schema as OtherInformationSchema } from '../subforms/OtherInformation';
import { NameAndContactSubForm, Schema as NameAndContactSchema } from '../subforms/NameAndContact';

export const OestStandardSchema = (settings) => (
    Yup.object()
        .concat(SalutationSchema)
        .concat(DocumentsSchema(settings))
        .concat(OtherInformationSchema)
        .concat(NameAndContactSchema(settings))
);

export const OestStandard = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>Die im Folgenden mit * markierten Felder sind Pflichtfelder.</Form.Text>
            <Field component={SalutationSubForm} colors={colors} />
            <Field component={NameAndContactSubForm} colors={colors} settings={settings} />
            <Field component={OtherInformationSubForm} colors={colors} />
            <Field component={DocumentsSubForm} colors={colors} settings={settings} />
        </>
    );
}